// deps
import React, { memo, useRef } from "react";

// interface
import { INoFeeWeekendData } from "@swiggy-private/cart-types";

// styles
import { Container, ContentContainer, FloatingCTA, TimeContainer } from "./style";

// Components
import { DialogHOC } from "@swiggy-private/core-ui";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import { default as ClearLightIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/clearLight/24";

// test-ids
import { NO_FEE_WEEKEND_POPUP_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { StyledGenericIcon } from "../delight-popup/styles";

export interface NoFeeWeekendPopupProps {
    data: INoFeeWeekendData | null;
    onClosePopup: VoidFunction;
    onAnimationEnd: VoidFunction;
    closeModal: VoidFunction;
}

const NoFeeWeekendPopup: React.FC<NoFeeWeekendPopupProps> = ({ data, onClosePopup, onAnimationEnd, closeModal }) => {
    const animationRef = useRef(null);

    return (
        <Container
            role="dialog"
            aria-modal="true"
            aria-label="No weekend fee campaign"
            data-testid={NO_FEE_WEEKEND_POPUP_TEST_IDS.POPUP}
        >
            <ContentContainer as="div">
                <Image cloudinaryId={data?.popup_comms?.image_id} width="100%" height="100%" />
                <StyledGenericIcon Icon={ClearLightIcon} onClick={onClosePopup} />
                <FloatingCTA>
                    <TextButton
                        data-testid={NO_FEE_WEEKEND_POPUP_TEST_IDS.CTA_BUTTON}
                        buttonSize="medium"
                        color="primary"
                        onClick={closeModal}
                    >
                        {NO_FEE_WEEKEND_POPUP_TEST_IDS.CTA_TEXT}
                    </TextButton>
                </FloatingCTA>
            </ContentContainer>
            <TimeContainer ref={animationRef} onAnimationEnd={onAnimationEnd} ctaColor="primary" />
        </Container>
    );
};

export default DialogHOC(memo(NoFeeWeekendPopup));
